/**
 * Match a trade against the Trades list search box (trade #, address, agent name).
 */
export function tradeMatchesSearch(trade, rawQuery) {
  const q = (rawQuery || "").trim().toLowerCase();
  if (!q) return true;

  const tradeNumber = (trade.tradeNumber ?? trade.keyInfo?.tradeNumber ?? "")
    .toString()
    .toLowerCase();
  if (tradeNumber.includes(q)) return true;

  const k = trade.keyInfo || {};
  const address = [
    k.streetNumber,
    k.streetName,
    k.unit,
    k.city,
    k.province,
    k.postalCode,
  ]
    .filter((part) => part != null && String(part).trim() !== "")
    .map((part) => String(part).trim())
    .join(" ")
    .toLowerCase();
  if (address.includes(q)) return true;

  const agents = trade.agentCommissionList || [];
  for (const a of agents) {
    const name = (a.agentName || "").trim().toLowerCase();
    if (name && name.includes(q)) return true;
  }

  return false;
}
